<template>
  <div class="personal-index">
     <div class="top">
          <img v-if="top_url" :src="top_url" />
      </div>
      <div class="KV">
          <img v-if="banner_url" :src="banner_url" />
      </div>
      <img class="avatar" :src="userInfo.avatar" v-if="userInfo.avatar"/>
      <img class="avatar" src="@/assets/images/default_user.png" v-else/>

      <div class="update">
          <van-form label-width="40%" input-align="right" error-message-align="right">
            <van-cell-group inset style="margin:0;">
                <p style="padding:10px;font-size:14px;color:#144A93;"
                v-if="updateDate">
                    最新个人信息修改时间:{{updateDate}}
                </p>
                <van-field
                v-model="form.username"
                name="姓名"
                label="姓名"
                placeholder="请输入"
                required
                :disabled="disabled"
                :rules="[{ required: true, message: '请填写' }]"
                />
                <van-field
                v-model="form.mobile"
                name="手机号"
                label="手机号"
                placeholder="请输入"
                required
                disabled
                :rules="[{ required: true, message: '请填写' }]"
                />
                <van-field
                    :value="title"
                    is-link
                    readonly
                    clickable
                    name="picker"
                    label="职称"
                    placeholder="请选择"
                    @click="disabled==false?showProPicker = true:''"
                    required
                    :rules="[{ required: true, message: '请选择' }]"
                    :disabled="disabled"
                />
                <van-popup v-model="showProPicker" position="bottom">
                <van-picker
                    show-toolbar
                    :columns="columns"
                    :default-index="defaultIndex"
                    @confirm="onConfirm"
                    @cancel="showProPicker = false"
                />
                </van-popup>

                <van-field
                    v-model="form.department"
                    name="科室"
                    label="科室"
                    placeholder="请输入"
                    required
                    :disabled="disabled"
                    :rules="[{ required: true, message: '请填写' }]"
                />
                <van-field
                v-model="form.hospital"
                name="单位"
                label="单位"
                placeholder="请输入"
                required
                :disabled="disabled"
                :rules="[{ required: true, message: '请填写' }]"
                />
                <van-field
                v-model="form.intro"
                name="简介（非必填）"
                label="简介（非必填）"
                :placeholder="disabled==true?'':'请输入'"
                error-message-align="center"
                :disabled="disabled"
                />
                <van-field
                :value="form.address"
                is-link
                readonly
                clickable
                name="addresspicker"
                label="收件地址"
                placeholder="请选择省市区"
                @click="disabled==false?showAddress = true:''"
                required
                :rules="[{ required: true, message: '请选择' }]"
                :disabled="disabled"
                />
                <van-popup v-model="showAddress" position="bottom">
                    <van-cascader
                        v-model="addressValue"
                        title="请选择所在地区"
                        :options="addressOptions"
                        :field-names="{text:'name',value:'id',children:'children'}"
                        @close="showAddress = false"
                        @change="onChange"
                    />
                </van-popup>

                <!-- <van-popup v-show="showAddress" position="bottom" style="height:300px">
                    <van-cascader
                        v-model="addressValue"
                        title="请选择所在地区"
                        :options="addressOptions"
                        field-names="{text:'name',value:'id',children:'children'}"
                        @close="showAddress = false"
                        @change="onChange"
                        @finish="onFinish"
                    />
                    为啥还得是三顿饭
                </van-popup> -->
                 <van-field
                    v-model="form.address_info"
                    name="详细地址"
                    label="详细地址"
                    placeholder="请输入"
                    required
                    :disabled="disabled"
                    :rules="[{ required: true, message: '请填写' }]"
                />
                <van-field
                    v-model="form.address_code"
                    name="邮编"
                    label="邮编"
                    placeholder="请输入"
                    required
                    :disabled="disabled"
                    :rules="[{ required: true, message: '请填写' }]"
                />
                 <van-field
                    v-model="form.address_mark"
                    name="备注（非必填）"
                    label="备注（非必填）"
                    :placeholder="disabled==true?'':'请输入'"
                    error-message-align="center"
                    :disabled="disabled"
                />
                <van-field name="uploader" input-align="center"
                v-model="form.photo"
                :rules="[{ required: true, message: '请上传个人照片' }]"
                 error-message-align="center"
                :disabled="disabled"

                >
                    <template #input>
                        <van-uploader v-model="fileList" :max-count="1"
                        :after-read="(file) => afterRead(file)"
                        :before-delete="(file) =>beforeDelete(file)"
                        :disabled="disabled"
                        :deletable="disabled==false">

                        </van-uploader>
                        <p><span style="color:#ee0a24;">*</span>点击上传个人照片</p>
                        <p style="color:#B5B5B5;margin:0;">您的照片将用于会议手册和会议系统的制作</p>
                    </template>
                </van-field>
            </van-cell-group>
            <div style="margin: 16px;">
                <van-button  block  
                style="background-color:#B01C06;color:white;border-radius:10px;"
                :disabled="buttonDisabled" @click="onSubmit">
                {{uploadText}}
                </van-button>
            </div>
        </van-form>
          
      </div>
      <!-- <div class="back" @click="goUpload()" style="bottom:90px;">
            <img src="@/assets/images/collection/upload_report.png" />
      </div>
      <div class="back" @click="goIndex()">
            <img src="@/assets/images/collection/back_index.png" />
      </div> -->
  </div>
</template>

<script>
import {PersoanalUserInfo,Titles,uploadImg,preWriters,ExpertInformation,Provinces} from '../../config/interface.js'
// import { Cascader } from 'vant';
export default {
    // comments:{
    //     Cascader
    // },
    data(){
        return{
            userInfo:{},
            form:{
                username:'',
                mobile:'',
                title:'',
                department:'',
                hospital:'',
                intro:'',
                photo:'',
                address:'',
                address_province_id:'',
                address_city_id:'',
                address_district_id:'',
                address_info:'',
                address_code:'',
                address_mark:''
            },
            addressValue:'',
            selectedAddress:[],
            title:'',
            showProPicker:false,
            showAddress:false,
            addressOptions:[],
            columns:[],
            fileList:[],
            uploadText:'提交个人信息',
            disabled:false,
            buttonDisabled:false,
            defaultIndex:0,
            updateDate:'',
            id:this.$route.query.id,
            top_url:'',
            banner_url:''
        }
    },
    created(){
        this.getUserInfo();
        this.getSetting();
        this.getProvinces();
        document.title="CEC官方";
        if(common.is_weixin()){
			common.wxShare('课题申报@中国血管论坛CEC2023','上报课题截止时间：2023年9月30日，欢迎您填写您的课题，谢谢您。','cdn.edstatic.com/203012120000/b20d0c68aad9dc88de3d7708dbf6c374/2022/07/9a6c31a0-d2f1-490c-8aa0-5942dc78e9dc.png');
		}

    },
    methods:{
        //得到用户信息
        getUserInfo(){
            const url=PersoanalUserInfo;
            let params={};
            const method='POST';
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                    let data=res.data;
                    localStorage.setItem('userInfo',JSON.stringify(data));
                    this.$store.dispatch('storageUserInfo',data);	
                    this.userInfo=data;
                    if(this.userInfo&&this.userInfo.mobile_status==1){
                        this.form.mobile=this.userInfo.mobile;
                        this.form.address_province_id=data.address_province_id;
                        this.form.address_city_id=data.address_city_id;
                        this.form.address_district_id=data.address_district_id;
                        this.form.address_info=data.address_info;
                        this.form.address_code=data.address_code;
                        this.form.address_mark=data.address_mark;
                        if(data.address_province&&data.address_city){
                            this.form.address=data.address_province.name+'/'+data.address_city.name;
                        }
                         if(data.address_district){
                            this.form.address+='/'+data.address_district.name;
                        }
                        this.getTitles();
                    }
                    else{
                        common.toast('未绑定手机',1000,'fail',()=>{
                                this.$router.replace({
                                path:'/collection/login',
                                query:{url:window.location.href}
                        })
                        })	
                    }
                }
            })
        },
        getTitles(){
            const url=Titles;
            let params={};
            const method='GET';
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                    let data=res.data;
                    this.columns=[];
                    for(let i=0;i<data.length;i++){
                        this.columns.push(
                            {id:data[i].id,text:data[i].name}
                        );
                    }
                    this.getInfo();
                }
            })

        },
        getProvinces(){
            const url=Provinces;
            let params={
                parent_id:0
            };
            const method='POST';
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                    // this.addressOptions=res.data;
                    this.addressOptions=[];
                    res.data.forEach(item=>{
                        this.addressOptions.push({
                            id:item.id,
                            name:item.name
                        })
                    })
//                     this.addressOptions=[{
//                         abbr_pinyin: "bjs",
// common: 1,
// full_name: "北京市",
// id: 110000,
// name: "北京市",
// parent_id: 0,
// pinyin: "beijingshi",
//                     },
//                     {
//                         abbr_pinyin: "tjs",
// common: 1,
// full_name: "天津市",
// id: 120000,
// name: "天津市",
// parent_id: 0,
// pinyin: "tianjinshi"
//                     },
//                     {

//                     }
//                     ]
                    console.log(this.addressOptions)
                }
            })

        },

        onChange({value,selectedOptions,tabIndex}){
            const url=Provinces;
            let params={
                parent_id:value
            };
            const method='POST';
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                    let data=res.data;
                    console.log(selectedOptions)
                    if(tabIndex==0){
                        this.$set(selectedOptions[0],'children',data)
                    }
                    else if(tabIndex==1&&data.length>0){
                        this.$set(selectedOptions[1],'children',data)
                    }
                    if((tabIndex==1||tabIndex==2)&&data.length==0){
                        this.showAddress = false;
                        this.selectedAddress=selectedOptions;
                        this.form.address = selectedOptions.map((option) => option.name).join('/');
                        this.form.address_province_id=selectedOptions[0].id;
                        this.form.address_city_id=selectedOptions[1].id;
                        if(tabIndex==2){
                            this.form.address_district_id=selectedOptions[2].id;
                        }
                    }
                }
            })

        },
        onFinish({ selectedOptions }) {
            // this.showAddress = false;
            // this.addressValue=selectedOptions;
            // if(selectedOptions.length==2&&selectedOptions[1]){

            // }
            // this.form.address = selectedOptions.map((option) => option.name).join('/');
            
        },
         getSetting(){
            const url='webapi/meetings/'+this.id+'/collects';
            //post必填参数，title,content，可选参数code
            let params={};
            const method='GET';
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                    let data=res.data;
                    this.top_url=data.top_img;
                    this.banner_url=data.banner;
                }
            })
        },
         getWriterDetail(){
            const url=ExpertInformation;
            let params={
                writer_id:this.userInfo.writer_id
            };
            const method='POST';
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                    let data=res.data;
                    if(data.name){
                        this.form.username=data.name;
                    }
                    if(data.title){
                        this.columns.forEach((item,index)=>{
                            if(item.id==data.title.id){
                                this.title=item.text;
                                this.form.title=data.title.id;
                                this.defaultIndex=index;
                            }
                        })
                    }
                    if(data.department){
                        this.form.department=data.department;
                    }
                    if(data.company){
                        this.form.hospital=data.company;
                    }
                    if(data.des){
                        this.form.intro=data.des
                    }
                    if(data.photo){
                        this.form.photo=data.photo;
                        this.fileList = [{ url: data.photo, isImage: true }];
                    }
                }
            })

        },
        getInfo(){
            const url=preWriters;
            let params={};
            const method='GET';
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                    let data=res.data;
                    // if(false){
                    if(data){
                        this.uploadText='修改个人信息';
                        this.disabled=true;
                        this.form.username=data.name;
                        this.form.mobile=data.mobile;
                        this.form.title=data.title_id;
                        this.form.department=data.department;
                        this.form.hospital=data.company;
                        this.form.intro=data.des;
                        this.form.photo=data.avatar;
                        this.fileList = [{ url: data.avatar, isImage: true }];
                        this.updateDate=this.transformDate(data.updated_at);
                        this.columns.forEach((item,index)=>{
                            if(item.id==this.form.title){
                                this.title=item.text;
                                this.defaultIndex=index;
                            }
                        })
                    }
                    else{
                        if(this.userInfo.is_writer){
                            this.getWriterDetail();

                        }
                    }
                }
            })

        },
        onSubmit(){
            console.log(this.disabled);
            if(this.disabled==false)
            {
                this.buttonDisabled=true;
                const url=preWriters;
                let params={
                    name:this.form.username,
                    title_id:this.form.title,
                    department:this.form.department,
                    company:this.form.hospital,
                    des:this.form.intro,
                    avatar:this.form.photo,
                    address_province_id:this.form.address_province_id,
                    address_city_id:this.form.address_city_id,
                    address_district_id:this.form.address_district_id,
                    address_info:this.form.address_info,
                    address_code:this.form.address_code,
                    address_mark:this.form.address_mark
                };
                const method='POST';
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        this.buttonDisabled=false;
                        this.disabled=true;
                        this.uploadText='修改个人信息';
                        this.updateDate=this.transformDate(res.data.updated_at);
                        if(res.error_msg){
                            common.toast(res.error_msg,2000,'success',()=>{
					    })
                        }
                        else{
                            common.toast("提交成功！",1000,'success',()=>{
					    })
                        }
                    }
                })
            }
            else{
                this.disabled=false;
                this.uploadText="提交个人信息修改";
            }
        },
        onConfirm(value){
            this.title=value.text;
            this.form.title=value.id;
            this.showProPicker=false;
        },
        goIndex(){
            this.$router.push({
				path:'/collection/index',
                query:{
                    id:this.id
                }
			});
        },
        goUpload(){
            this.$router.push({
				path:'/collection/subject',
                query:{
                    id:this.id,
                }
			});
        },
        afterRead(file){
            const url=uploadImg;  
            let formData=new FormData();
            formData.append('file',file.file);
            const method='POST';
            fetch(url,formData,method)
            .then((res)=>{
                if(res.code==0){
                    this.form.photo=res.data.path;
                }
            })
        },
        beforeDelete(file){
            this.form.photo='';
            return  ()=>{}
        },
        transformDate(str){
            if(str){
                str=str.split(" ")[0];
                let arr=str.split("-");
                return arr[0]+"年"+arr[1]+"月"+arr[2]+"日";
            }
            return "";
        }
        

    }

}
</script>

<style lang="scss">
.personal-index{
    margin-bottom: 30px;
    .top{
        img{
            width: 100%;
        }
    }
    .KV{
        margin: 15px 15px 0;
        img{
            width: 100%;
            border-radius: 10px;
        }
    }
    .avatar{
        display: block;
        margin: 0 auto;
        border-radius: 50%;
        width: 60px;
        margin-top:-40px;
        border: 2px solid #8addeb;
        // 解决ios边框显示一半的问题
        transform: rotateZ(360deg);

    }
    .update{
        margin: 0 15px;
        border-radius: 5px;
        box-shadow: 0px 2px 4px #f2f2f2; 
        .van-cell{
            line-height: 1rem;
            font-size: 16px;
        }
        .van-field__control--custom{
            display: block !important;
        }
        .van-cell__right-icon{
            line-height: 1rem;
        }

    }
    .back{
        position: fixed;
        right: 0;
        bottom: 30px;
        img{
            height: 40px;
        }
    }
    
    
}
.van-field--disabled .van-field__label {
    color: #323233 !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/Contributions/personal.vue